import { useSyncExternalStore } from 'react'
import { CLUB_AERODROME, CLUB_LOCATION, type HomeBasePoint } from '@jupi/shared'

// The club's home airfield and where it is: what the sun times (header icon,
// calendar shading, night warning) are for. Set from GET /api/time by the
// clock; until that lands, and if the setting names an unknown point, it is
// the default home field.

const DEFAULT: HomeBasePoint = { code: CLUB_AERODROME, ...CLUB_LOCATION }
let current: HomeBasePoint = DEFAULT
const listeners = new Set<() => void>()

export const getClubLocation = () => current

export function setClubLocation(point: HomeBasePoint | null | undefined) {
  const next = point ?? DEFAULT
  if (next.code === current.code && next.lat === current.lat && next.lon === current.lon) return
  current = next
  for (const listener of listeners) listener()
}

export function useClubLocation(): HomeBasePoint {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener)
      return () => listeners.delete(listener)
    },
    () => current,
  )
}
